// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3Vd8V","main-image":"Header_main-image__1wOpG"};